export default __webpack_public_path__ + "static/media/22.39804e18.jpg";